import { groupBy, uniq } from 'es-toolkit';

import { PlateOption } from '@paragon/contract-library';
import { getComboPlateType, isComboPlateType } from '@paragon/material-lists';

export function tangiblePlateOptionsToComboPlateOptions(inputPlateOptions: readonly PlateOption[]): PlateOption[] {
  const inputTangiblePlateOptions = comboPlateTypesToTangiblePlateTypes(inputPlateOptions);

  const plateOptions: PlateOption[] = [];
  const platesByWidth = groupBy(inputTangiblePlateOptions, (plate) => plate.width);
  for (const platesOfWidth of Object.values(platesByWidth)) {
    const platesByWidthAndLength = groupBy(platesOfWidth, (plate) => plate.length);
    for (const platesOfWidthAndLength of Object.values(platesByWidthAndLength)) {
      const platesByWidthAndLengthAndComboPlateType = groupBy(platesOfWidthAndLength, (plate) =>
        getComboPlateType(plate.plateType),
      );
      for (const platesOfWidthAndLengthAndComboPlateType of Object.values(platesByWidthAndLengthAndComboPlateType)) {
        const comboPlateType = getComboPlateType(platesOfWidthAndLengthAndComboPlateType[0].plateType);
        if (platesOfWidthAndLengthAndComboPlateType.length > 1) {
          const comboPlate: PlateOption = {
            width: platesOfWidthAndLengthAndComboPlateType[0].width,
            length: platesOfWidthAndLengthAndComboPlateType[0].length,
            geometryType: platesOfWidthAndLengthAndComboPlateType[0].geometryType,
            plateType: comboPlateType,
            tangiblePlateTypesForComboPlateType: uniq(
              platesOfWidthAndLengthAndComboPlateType.map((plate) => plate.plateType),
            ),
          };
          plateOptions.push(comboPlate);
        } else plateOptions.push(platesOfWidthAndLengthAndComboPlateType[0]);
      }
    }
  }

  return plateOptions;
}

export function comboPlateTypesToTangiblePlateTypes(plateOptions: readonly PlateOption[]): PlateOption[] {
  const tangiblePlateOptions: PlateOption[] = [];
  for (const plateOption of plateOptions) {
    if (isComboPlateType(plateOption.plateType)) {
      for (const tangiblePlateType of plateOption.tangiblePlateTypesForComboPlateType) {
        tangiblePlateOptions.push({
          width: plateOption.width,
          length: plateOption.length,
          geometryType: plateOption.geometryType,
          plateType: tangiblePlateType,
          tangiblePlateTypesForComboPlateType: [],
        });
      }
    } else tangiblePlateOptions.push(plateOption);
  }
  return tangiblePlateOptions;
}
